'use strict';

import Axios from '@/plugins/axios';

// Process ENV Details
const api = Axios({ baseURL: process.env.VUE_APP_BASE_API });

export default api;
